import { styled } from "@linaria/react";
import { useSearch } from "@tanstack/react-router";

import Modal from "@gx/dls/modal/Modal";
import { withTheme } from "@gx/dls/theme/GalaxyTheme";
import { PropsWithTheme } from "@gx/dls/theme/types";

import SourcesPage from "@/pages/sources/SourcesPage";

interface SourcesModalProps {
  onClose: () => void;
}

const SourcesModalWrapper = withTheme(styled.div<PropsWithTheme>`
  display: flex;
  flex-direction: column;

  height: calc(100vh - 128px);
  width: calc(100vw - 128px);

  background-color: ${({ theme }) => theme.color.background.primary};
  border: 0.5px solid ${({ theme }) => theme.color.border.primary};
  border-radius: 8px;
`);

const SourcesModal = ({ onClose }: SourcesModalProps) => {
  const { sources } = useSearch({ from: "__root__" });

  const isOpen = sources === true;

  return (
    <Modal open={isOpen} onClose={onClose}>
      <SourcesModalWrapper>
        <SourcesPage onClose={onClose} />
      </SourcesModalWrapper>
    </Modal>
  );
};

export default SourcesModal;
